import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap } from 'rxjs/operators';
import { of } from 'rxjs';

import * as ValidateDnsActions from '../actions/validate-dns.actions';
import { OrganizationsService } from '../../../services/api/organizations/organizations.service';



@Injectable()
export class ValidateDnsEffects {

  validateDns$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ValidateDnsActions.validateDns),
      concatMap((payload) =>
        this.organizationsService.validateDns(payload.data).pipe(
          map(data => ValidateDnsActions.validateDnsSuccess({ data })),
          catchError(error => of(ValidateDnsActions.validateDnsFailure({ error }))))
      )
    );
  });



  constructor(private actions$: Actions,
              private organizationsService: OrganizationsService) {}

}
